import IconPlus from "@Icons/controls/IconPlus";
import {Colors} from "@Styles/Colors.style";
import {ReactNode} from "react";
import useIsMobile from "@Hooks/selector/useIsMobile";

interface AddTicketExtraProps {
    title: string,
    description?: string,
    icon: ReactNode,
    openSelection: () => void,
    isUpdating: boolean
    isCard?: boolean,
}

/**
 * Used by both Addons and Amenities as a "cta". to add ticket-extra.
 * (Ticket extra === additional "service")
 */
function AddTicketExtra({title, description, icon, openSelection, isUpdating, isCard}: AddTicketExtraProps) {
    const isMobile = useIsMobile()

    return (
        <button
            type="button"
            className={`${isCard ? "gb--card" : ""} manage-ticket-extras__add`}
            disabled={isUpdating}
            onClick={openSelection}
        >
            <div className="add-card">
                <IconPlus
                    fill={Colors.primaryColor}
                    backgroundFill="none"
                    width={isMobile ? "30" : "36"}
                    height={isMobile ? "30" : "36"}
                />
                <span className="gb--card-title">
                    {title}
                </span>
                {!isMobile && description && (
                    <span className="add-card__description">
                        {description}
                    </span>
                )}
            </div>
            {icon}
        </button>
    )
}

export default AddTicketExtra